export interface Notice {
  id: string;
  title: string;
  author: string;
  date: string;
  content: string;
  image?: string;
  isPinned?: boolean;
}

export const notices: Notice[] = [
  {
    id: 'notice-006',
    title: "투빅스(TOBIG's) 26기 최종합격자 발표 및 OT 안내",
    author: '운영진',
    date: '2026-07-01',
    content: `안녕하세요. 투빅스(TOBIG'S) 25기 운영진입니다.

투빅스 26기 최종 합격자를 발표합니다.

tobigi.png

먼저 투빅스 26기 모집에 지원해 주신 모든 분들께 진심으로 감사드립니다.

아쉽게도 이번 기수에서 함께하지 못한 분들께는 깊은 감사의 말씀을 전합니다. 이번 결과는 동아리와의 방향성과 모집 인원 등 여러 요소를 종합적으로 고려한 결과이며, 지원자 여러분의 역량과 가능성을 의미하는 것은 아닙니다. 앞으로도 각자의 자리에서 더욱 큰 성장을 이루시길 진심으로 응원하겠습니다.

최종 합격하신 모든 분들께 진심으로 축하의 말씀을 전합니다. 투빅스의 새로운 일원이 되신 것을 환영합니다!

OT 안내

* 일시: 2026년 7월 4일(토) 14:00 ~ 17:00
* 장소: 서울시립대학교 정보기술관 110호

합격자분들께는 개별 합격 문자를 순차적으로 발송드릴 예정이니 확인 부탁드립니다.

안내사항

* OT와 컨퍼런스는 모두 필수 참석입니다.
* 부득이한 사유 없이 불참하거나, 참석 여부를 회신하지 않는 경우 합격 포기로 간주될 수 있습니다.
* 참석 여부는 안내 문자에 회신해 주시기 바랍니다.

다시 한번 투빅스에 지원해 주신 모든 분들께 감사드리며, 최종 합격하신 분들께 진심으로 축하의 말씀을 전합니다.`,
    image: 'https://storage.readdy-site.link/project_files/08aeba0a-a656-461b-aef6-541b167b6190/a2636d4c-6190-47c5-80a7-55fa8710aa61_compressed_tobigi.webp',
    isPinned: true,
  },
  {
    id: 'notice-005',
    title: "투빅스(TOBIG's) 26기 1차 합격자 및 면접 시간 안내",
    author: '운영진',
    date: '2026-06-26',
    content: `안녕하세요 인공지능 및 데이터분석 대표 연합동아리 투빅스 입니다.

26기 모집에 관심을 가져주신 모든 지원자 분들께 감사드립니다.

높은 경쟁률을 뚫고 26기 서류 전형에 합격하신 모든 분께 축하의 말씀을 드리며, 본인 면접 시간을 확인해주시기 바랍니다.

본인 이름 가운데 자는 * 로 가려져 있고, 뒤의 괄호는 본인 전화번호 뒷자리로 표시되었습니다.

면접은 사전에 공지된 대로 6월 28일(일) ~ 6월 30일(화)에 진행되며, 면접대기 장소는 서울시립대학교 미래관 B111호입니다.

원활한 진행을 위해 면접 시간 10분 전까지 도착 바랍니다.
작성해주신 지원서를 토대로 면접을 진행할 예정이니, 참고 부탁드립니다.

다시 한번 지원해주신 모든 분들께 감사드립니다.`,
    image: 'https://storage.readdy-site.link/project_files/08aeba0a-a656-461b-aef6-541b167b6190/6842618a-07fb-4332-ad8f-3584b9e8c692_compressed_-2026.-6.-26.--5.39.webp',
    isPinned: false,
  },
  {
    id: 'notice-001',
    title: "[공지] TOBIG's 신입기수(26기) 모집",
    author: '운영진',
    date: '2026-06-04',
    content: `안녕하세요, 투빅스 25기 운영진입니다.
저희와 함께 성장할 26기 신입 부원을 모집합니다.

주요 활동
투빅스는 정규 세션과 심화 세션을 격주로 번갈아 운영합니다.

정규 세션 : 데이터 분석 / AI 두 가지 트랙으로 나뉘어 진행
심화 세션 : 수학, DE, DA, AI 등 관심 분야 심화 학습 및 공모전 · 학회 참가

매 기수마다 팀을 구성하여 컨퍼런스 프로젝트를 수행하며, AI 포럼, 데이터톤, 공모전 참가를 적극 지원합니다. 기업 및 타 동아리와 협력하는 연합 데이터톤을 통해 실전 경험과 네트워킹 기회를 제공하며, 실무자·연구자 초청 강연 및 선배와의 네트워킹 행사도 정기적으로 운영합니다.
투빅스는 활동량이 많은 편으로, 세션 및 과제 수행을 위한 일정 수준의 몰입이 요구됩니다. 함께 성장하고자 하는 열정 있는 분들의 많은 지원 바랍니다.

활동 일정

정규 세션 : 격주 토요일 14:00 ~ 17:00
심화 세션 : 격주 토요일 (팀 내 자율 조정)

활동 기간 : 2026년 7월 ~ 2027년 7월 (1년)
활동 장소 : 서울 소재 대학 강의실
지원 자격 : 1년간 성실히 참여 가능한 대학(원)생

모집 일정

서류 접수 : 6. 4(목) ~ 6. 23(화) 23:59
서류 합격자 발표 : 6. 26(금)
면접 : 6. 28(일) ~ 6. 30(화)
최종 합격자 발표 : 7. 1(수)
OT : 7. 4(토)
컨퍼런스 : 7. 11(토)

※ 면접, OT, 컨퍼런스는 모두 오프라인으로 진행됩니다.

필수 참석 안내
최종 합격자(26기)는 OT 및 컨퍼런스에 반드시 참석하여야 하며, 불참 시 합격이 취소됩니다.
OT 이후 중도 탈퇴 시에는 회비 환불이 불가합니다.

동아리 회비
학기당 50,000원 (보증금 10,000원 별도)
※ 회비는 운영비 및 컨퍼런스 준비 등에 사용되며, 회계 내역은 전체 부원에게 투명하게 공개됩니다.

관련 링크

투빅스 Notion : https://app.notion.com/p/ToBig-s-26-ea07e01ca733825290b50170d4a3601a
카카오톡 채널 Q&A : https://pf.kakao.com/_QyxiDxb

문의 : 카카오톡 공식 채널 또는 인스타그램 DM (@tobigs_official)

※ 본 동아리는 대학생에 의해 자치적으로 운영되며, 정치·종교·시민 단체와 무관합니다.`,
    isPinned: false,
  },
  {
    id: 'notice-002',
    title: "인공지능 및 데이터 분석 대표 연합 동아리 투빅스 TOBIG's 신입기수(25기) 모집",
    author: '운영진',
    date: '2025-12-17',
    content: `인공지능 및 데이터 분석 대표 연합 동아리 투빅스 TOBIG's 신입기수(25기) 모집 [12/17(수) ~ 12/31(수)]

안녕하세요! 인공지능 및 데이터 분석 연합 대표 동아리 투빅스, 24기 운영진입니다.

저희와 함께 공부하고 성장할 신입 투빅이(25기)를 모집합니다!

주요 활동

투빅스는 정규 세션을 통해 데이터 분석, 머신러닝, 딥러닝 관련 집중 교육을 진행합니다.

이후에는 각자의 관심 분야(생성모델, 음성, 시각화, 이미지, 텍스트, 추천시스템, 데이터 엔지니어링, 시계열, MLOps 등)에 따라 심화 세미나를 이어가며, 매 기수마다 컨퍼런스 팀 프로젝트를 진행합니다.

또한, 부족한 부분을 보완하기 위한 스터디 활동(선형대수, 딥러닝, 시각화 등)도 함께 운영하며,

관심사를 공유하는 부원들과 함께 AI 포럼, 데이터톤, 공모전에 참가할 수 있도록 적극 지원합니다.

특히 기업 및 타 동아리와 협력하여 진행하는 자체 데이터톤을 통해 실전 경험과 네트워킹 기회도 제공합니다.

이외에도 다양한 실무자·연구자를 모시는 연사 초청 강연,

졸업한 선배들과 직접 소통하며 진로를 고민할 수 있는 네트워킹 행사도 마련되어 있습니다.

투빅스는 활동량이 많은 편이며, 세션 및 과제를 소화하기 위해서는 일정 시간의 몰입이 필요합니다.

하지만 그만큼 함께 성장하고 싶은 열정을 가진 여러분을 기다리고 있습니다.

TOBIG's가 의미하는 대로,

"큰 사람이 될 준비가 된" 여러분의 많은 지원을 기다립니다!

활동 일시

정규 세션: 격주 토요일 14:00~17:00 (총 10주)

심화 세션: 격주 토요일 (팀별 일정 상이)

활동 기간

2026년 1월 ~ 2027년 1월 (1년)

활동 장소

서울 소재 대학 강의실

지원 자격

1년간 성실히 참여할 수 있는 대학(원)생

모집 일정

서류 접수: 12월 17일(수) ~ 12월 31일(수) 밤 11시 59분 59초

서류 합격자 발표: 1월 5일(월)

면접: 1월 10일(토)

최종 합격자 발표: 1월 12일(월)

OT: 1월 17일(토)

컨퍼런스: 1월 24일(토)

※ 면접, OT, 컨퍼런스는 모두 오프라인으로 진행될 예정입니다.

※ OT 이후 중도 탈퇴시에는 회비 환불이 불가합니다.

필수 참석 안내

합격한 25기 분들은 신입기수 OT와 컨퍼런스에 반드시 참석해야 하며,

불참 시 합격이 취소됩니다!

동아리 회비

학기 당 6만 원 (보증금 1만 원 포함)

※ 운영비, 컨퍼런스 준비 등에 사용되며, 회계 내역은 동아리원에게 투명하게 공개됩니다.

동아리에 대해 더 알고 싶다면?

- 투빅스 Notion: https://www.notion.so/ToBig-s-25-2c6a2756fda4813f9a2bc38ed9b4438c?source=copy_link

- 투빅스 홈페이지: https://datamarket-tobigs.github.io/

- 카카오톡 공식 채널 Q&A: https://pf.kakao.com/_QyxiDxb

문의 사항

카카오톡 공식 채널 또는 이메일 datamarket.tobigs@gmail.com으로 언제든지 문의 주세요!

25기 지원하기 : https://forms.gle/Jj26QtF2hXexGHdN8

본 동아리는 대학생에 의해 자치적으로 운영되며, 정치, 종교, 시민 단체와 전혀 무관함을 알려드립니다.`,
    isPinned: false,
  },
  {
    id: 'notice-003',
    title: '투빅스 25기 1차 합격자 및 면접 시간 안내',
    author: '운영진',
    date: '2026-01-05',
    content: `안녕하세요 인공지능 및 데이터분석 대표 연합동아리 투빅스 입니다.

25기 모집에 관심을 가져주신 모든 지원자 분들께 감사드립니다.

높은 경쟁률을 뚫고 25기 서류 전형에 합격하신 모든 분께 축하의 말씀을 드리며, 본인 면접 시간을 확인해주시기 바랍니다.

본인 이름 가운데 자는 * 로 가려져 있고, 뒤의 괄호는 본인 전화번호 뒷자리로 표시되었습니다.

면접은 사전에 공지된 대로 1월 10일(토)에 진행되며,

면접대기 장소는 서울시립대학교 미래관 B202호입니다.

원활한 진행을 위해 면접 시간 10분 전까지 도착 바랍니다.

작성해주신 지원서를 토대로 면접을 진행할 예정이니, 참고 부탁드립니다.

다시 한번 지원해주신 모든 분들께 감사드립니다.`,
    isPinned: false,
  },
  {
    id: 'notice-004',
    title: '투빅스 25기 최종합격자 발표 및 OT 안내',
    author: '운영진',
    date: '2026-01-12',
    content: `안녕하세요, 투빅스 24기 운영진입니다.

투빅스 25기 합격자는 다음과 같습니다.

아쉽게 탈락하신 분들은 동아리와 방향성이 맞지 않았을 뿐

뛰어난 능력과 잠재력을 가지고 있으며,

다른 곳에서 더욱 빛을 발할 수 있을 것입니다.

앞으로도 여러분들의 꿈과 목표를 향해 계속 나아가시길 응원합니다.

지원해주신 모든 분들께 감사드립니다.

최종 합격하신 분들, 모두 축하드립니다!

아래의 OT 일정 확인해주시기 바랍니다.

일정 : 2026년 1월 17일 (토) 15:00 ~ 18:00

장소 : 서울시립대 정보기술관 1층 강의실

(정확한 강의실은 추후 공지 예정입니다)

합격자 분들께는 모두 합격 문자를 보내드릴 예정이니, 확인하시길 바랍니다.

주의사항 : OT 와 컨퍼런스 참석은 필수이며,

불참시 합격 포기로 간주합니다.

참석 여부는 문자로 답해주시기 바랍니다.`,
    isPinned: false,
  },
];